import * as echarts from 'echarts'
import { EChartsOption } from 'echarts'

export default function (el: HTMLElement) {
  const myChart = echarts.init(el)
  let disposed = false

  const setOption = (option: EChartsOption) => {
    myChart.setOption(option)
  }

  const resize = () => {
    if (!disposed) myChart.resize()
  }

  const resizeObserver = new (window as any).ResizeObserver(resize)
  resizeObserver.observe(el)

  const dispose = () => {
    if (disposed) return
    disposed = true
    resizeObserver.disconnect()
    window.removeEventListener('resize', resize)
    myChart.dispose()
  }

  window.addEventListener('resize', resize)

  return {
    myChart,
    setOption,
    resize,
    dispose
  }
}
